import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ISoftware, TriggerInfo } from "./types";
import { RootState } from "app/redux/store";
import { ReducerStatus } from "model/IReducerState";
import RESTGatewayAPI from "api/gatewayAPI";
import { selectCurrentUuid } from "app/redux/applicationSlice";
import { removeDuplicatesBy } from "utils/removeDuplicates";

interface OptimizationState {
  /* Software Gaming */
  software: ISoftware[];
  /* status */
  status: ReducerStatus;
}

export const fetchJittriggersScan = createAsyncThunk<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  void,
  { state: RootState }
>("scan/fetchJittriggersScan", async (_, thunkApi) => {
  const state = thunkApi.getState();
  const uuid = selectCurrentUuid(state);
  const url = `/api/scan/jittriggers/${uuid}`;
  let apiResponse = null;

  await RESTGatewayAPI.get(url)
    .then((response) => {
      apiResponse = JSON.parse(response.data.payload);
    })
    .catch((error) => {
      return thunkApi.rejectWithValue(`Unable to fetch JIT Trigger scan : ${error}`);
    });

  if (apiResponse == null) {
    return thunkApi.rejectWithValue(`Unable to fetch JIT Trigger scan : response was empty`);
  }

  return apiResponse;
});

const initialState: OptimizationState = {
  software: [],
  status: ReducerStatus.Idle,
};

const optimizationSlice = createSlice({
  name: "familyMembers",
  initialState,
  reducers: {
    resetOptimizationState: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchJittriggersScan?.fulfilled, (state, action) => {
      state.software = {
        ...action.payload,
        TriggerInfo: removeDuplicatesBy(
          (x: TriggerInfo) => x?.JitTrigger?.ManagedSoftwareID,
          action?.payload?.TriggerInfo
        )?.sort((a, b) => {
          // toLocale will work better but for compatibility
          const idA = a?.JitTrigger?.ManagedSoftware?.Description?.toLowerCase();
          const idB = b?.JitTrigger?.ManagedSoftware?.Description?.toLowerCase();
          //sort string ascending
          if (idA < idB) return -1;
          //  if (idA > idB) return 1; If I want descending
          return 0; //default return value (no sorting)
        }),
      };
      state.status = ReducerStatus.Succeeded;
    });
  },
});

export const { resetOptimizationState } = optimizationSlice.actions;

export default optimizationSlice.reducer;

export const getSoftware = (state: RootState) => state.optimization.software;
export const getOptimizationStatus = (state: RootState) => state.optimization.status;
